import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
//
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './app.guard';
const routes: Routes = [
  // //login
  // { path: 'login', component: LoginComponent, canActivate: [AuthGuard]  },
  // //admin
    { path: '', redirectTo: '/login', pathMatch: 'full' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts